<template>
  <CommonDialog
    :dialog="dialogReal"
    :head-text="$t(`${resource}.${filterLabel}`)"
    :on-confirm="
      () => {
        dialogReal = false;
        $emit('update:filterType', filter_type);
        if (filterLabel === 'value-filter') {
          $emit('update:valueFilter', value_filter);
        } else {
          $emit('update:timeFilter', time_filter);
        }
      }
    "
    :on-cancel="
      () => {
        dialogReal = false;
      }
    "
    max-width="1200px"
  >
    <v-form ref="form" :class="{ mobile: $vuetify.breakpoint.mdAndDown }">
      <v-flex class="flex-wrap">
        <div class="left-col">
          <v-autocomplete
            :label="$t('transmissions.sources')"
            v-model="source_id"
            :items="sources"
            :disabled="!(sources && sources.length)"
            item-value="id"
            :item-text="i => i.name"
          ></v-autocomplete>
          <v-autocomplete
            :label="$t(`${resource}.items`)"
            v-model="item_id"
            :items="items"
            :disabled="!(items && items.length)"
            item-value="id"
            :item-text="
              i => $dateTime(i.receive_time, 'long', '', project.timezone)
            "
            :loading="loadingTransmissions"
          ></v-autocomplete>
          <v-autocomplete
            :label="$t(`${resource}.filter-type`)"
            v-model="filter_type"
            :items="filter_types"
          ></v-autocomplete>
          <v-text-field
            v-if="filterLabel === 'time-filter'"
            :label="$t(`${resource}.time-filter`)"
            v-model="time_filter"
            :rules="[backEndValidation('filter')]"
          ></v-text-field>
          <v-text-field
            v-else
            :label="$t(`${resource}.value-filter`)"
            v-model="value_filter"
            :rules="[backEndValidation('filter')]"
          ></v-text-field>
          <v-btn color="primary" v-on:click="parse()" :loading="loadingParse">
            <v-icon left>mdi-reload</v-icon>
            {{ $t(`buttons.parse`) }}
          </v-btn>
        </div>
        <div class="codemirror-item">
          <codemirror
            :options="options"
            v-model="itemCode"
            class="codemirror"
          ></codemirror>
          <v-text-field
            class="hide-input"
            :rules="[backEndValidation('data')]"
          ></v-text-field>
        </div>
        <v-divider class="divider my-5" />
        <div class="left-col">
          <v-text-field
            v-model="record_value"
            :label="$t(`${resource}.record-value`)"
            readonly
          ></v-text-field>
        </div>
        <div class="codemirror-item">
          <codemirror
            :options="{ ...options, readOnly: true }"
            :value="full_result"
            class="codemirror"
          ></codemirror>
        </div>
      </v-flex>
    </v-form>
  </CommonDialog>
</template>

<script>
import XmlBeautify from "xml-beautify";
import { rules } from "../../../mixins/rules";
import CommonDialog from "../../../common/dialogs/CommonDialog";
import { codemirror } from "vue-codemirror";
export default {
  name: "DialogValueFilterIngestion",
  mixins: [rules],
  components: { CommonDialog, codemirror },
  props: {
    project: {
      type: Object
    },
    dialog: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    valueFilter: {
      type: String
    },
    timeFilter: {
      type: String
    },
    filterType: {
      type: String
    },
    filterLabel: {
      type: String
    },
    resource: {
      type: String,
      default: "ingestions"
    },
    store: {
      type: String,
      default: "projectMeteringStore/transmissionStore"
    },
    codeItemKey: {
      type: String,
      default: "data"
    }
  },
  data() {
    return {
      item_id: "",
      itemCode: "",
      source_id: "",
      value: "",
      filter_type: "",
      filter_types: ["jsonpath", "xpath", "regex"],
      value_filter: "",
      time_filter: "",
      filter_label: "",
      filter_name: "",
      full_result: "",
      record_value: "",
      loadingParse: false,
      loadingTransmissions: false
    };
  },
  methods: {
    getTransmissions() {
      if (this.project_id && this.source_id) {
        this.loadingTransmissions = true;
        this.$store
          .dispatch(`${this.store}/getList`, {
            params: {
              project_id: this.project_id,
              filters: {
                source: this.source_id
              }
            }
          })
          .finally(() => (this.loadingTransmissions = false));
      }
    },
    getTransmission() {
      if (this.project_id && this.item_id) {
        this.$store.dispatch(`${this.store}/get`, {
          id: this.item_id,
          project_id: this.project_id
        });
      }
    },
    getSources() {
      this.$store.dispatch("projectMeteringStore/sourceStore/getList", {
        params: { limit: -1, project_id: this.project_id }
      });
    },
    updateTransmissionDependencies() {
      this.itemCode = this.getCodeFromItem();
    },
    getCodeFromItem() {
      if (this.item && this.item[this.codeItemKey]) {
        if (this.item.data_type === "json") {
          return JSON.stringify(
            JSON.parse(this.item && this.item[this.codeItemKey]),
            null,
            4
          );
        }
        if (this.item.data_type === "xml") {
          return new XmlBeautify().beautify(
            this.item && this.item[this.codeItemKey],
            {
              indent: "  ", //indent pattern like white spaces
              useSelfClosingElement: true //true:use self-closing element when empty element.
            }
          );
        }
      }
      return (this.item && this.item[this.codeItemKey]) || "";
    },
    parse() {
      this.loadingParse = true;
      this.clearBackEndErrors();
      let params = {
        data: this.itemCode,
        filter_type: this.filter_type,
        filter_string:
          this.filter_label === "time-filter"
            ? this.time_filter
            : this.value_filter
      };
      this.$store
        .dispatch(`${this.store}/testFilter`, {
          params,
          errorHandler: this.errorHandler.bind(this, () => {
            this.$refs.form.validate();
          }),
          onSuccess: res => {
            this.record_value = res.record_value;
            if (res.full_result && res.full_result.length) {
              this.full_result = `[\n  ${res.full_result.join(",\n  ")}\n]`;
            } else {
              this.full_result = `[]`;
            }
          }
        })
        .finally(() => (this.loadingParse = false));
    }
  },
  computed: {
    item: {
      get() {
        return this.$store.getters[`${this.store}/getItem`];
      }
    },
    items: {
      get() {
        return this.$store.getters[`${this.store}/getList`];
      }
    },
    sources() {
      return this.$store.getters["projectMeteringStore/sourceStore/getList"];
    },
    options: {
      get() {
        return {
          lineNumbers: true,
          foldGutter: true,
          fixedGutter: false,
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
          mode:
            this.item.data_type === "json"
              ? "application/json"
              : this.item.data_type
        };
      }
    },
    project_id() {
      return this.project && this.project.id;
    },
    dialogReal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("update:dialog", val);
      }
    }
  },
  watch: {
    source_id() {
      this.getTransmissions();
    },
    project_id() {
      this.getTransmissions();
    },
    item_id() {
      this.getTransmission();
    },
    valueFilter(val) {
      this.value_filter = val;
    },
    timeFilter(val) {
      this.time_filter = val;
    },
    filterType(val) {
      this.filter_type = val;
    },
    filterLabel(val) {
      this.filter_label = val;
    },
    item: {
      handler: function() {
        this.updateTransmissionDependencies();
      },
      deep: true
    }
  },
  mounted() {
    this.getSources();
    //this.getTransmissions();
    this.value_filter = this.valueFilter;
    this.time_filter = this.timeFilter;
    this.filter_type = this.filterType;
    this.filter_label = this.filterLabel;
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.left-col {
  flex: 0 0 320px;
}
.divider {
  flex: 0 0 100%;
}
.codemirror-item {
  width: calc(100% - 340px);
  height: 270px;
  margin-left: 20px;
  .codemirror {
    height: calc(100% - 25px);
    &::v-deep .CodeMirror {
      height: 100%;
      width: 100%;
    }
  }
}
.hide-input::v-deep .v-input__slot {
  display: none;
}
.mobile {
  .flex {
    display: block;
  }
  .codemirror-item {
    width: 100%;
    margin-top: 20px;
    margin-left: 0;
  }
}
</style>
